<template>
  <div>
    <navbar :title="title"></navbar>
    <div style="padding-top: 80px;background:#fbfbfb;">
      <div class="personalMsg-title">
        <img :src="staticImage+'personalMsgIcon.png'" />
        <span>个人信息</span>
      </div>

      <div class="personalMsg">
        <div class="owner-item">
          <div style="display:flex;width: 100%;align-items: center;">
            <span>证件类型</span>
            <el-select v-model="type" placeholder="请选择" @change="getType">
              <el-option
                v-for="item in typePickers"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="owner-pic">
          <template v-if="isOtherPage">
            <template v-if="cardPic">
              <div>
                <img
                  class="norotate"
                  :src="cardPic"
                  @click="showPic"
                  style="background-color:#fff;object-fit:contain;"
                />
                <div class="DelImg" @click="DelImg(1)">
                  <img src="../../public/close.png" />
                </div>
              </div>
            </template>
            <template v-else>
              <div @click="showFloat(1)">
                <span class="jia">+</span>
                <span class="text">上传证件正面照</span>
              </div>
            </template>
          </template>
          <template v-else>
            <template v-if="info.idCardPic">
              <div>
                <img
                  class="norotate"
                  :src="info.idCardPic"
                  @click="showPic"
                  style="background-color:#fff;object-fit:contain;"
                />
                <div class="DelImg" @click="DelImg(1)">
                  <img src="../../public/close.png" />
                </div>
              </div>
            </template>
            <template v-else>
              <div data-num="1" @click="showFloat(1)">
                <span class="jia">+</span>
                <span class="text">上传身份证正面</span>
              </div>
            </template>
          </template>
          <template v-if="info.facePic">
            <div>
              <img
                :src="info.facePic"
                @click="showPic"
                style="width:100%;height:100%;object-fit:contain;"
              />
              <div class="DelImg" @click="DelImg(2)">
                <img src="../../public/close.png" />
              </div>
            </div>
          </template>
          <template v-else>
            <div @click="showFloat(2)">
              <span class="jia">+</span>
              <span class="text">上传正面人脸照</span>
            </div>
          </template>
        </div>

        <div class="owner-item">
          <div style="display:flex;width: 100%;">
            姓名：
            <input
              v-model="submitData.personneName"
              style="width: 81%;"
              placeholder="请输入姓名"
              placeholder-style="color:#bfbfbf;font-size: 16px;"
            />
          </div>
        </div>

        <div class="owner-item">
          <div style="display:flex;width: 100%;">
            <span>性别：</span>
            <input
              placeholder="请输入性别"
              style="left: -4px;"
              placeholder-style="color:#bfbfbf"
              maxlength="1"
              v-model="info.sex"
              @change="getSex"
            />
          </div>
        </div>

        <div class="owner-item">
          <div style="display:flex;width: 100%;">
            <span>民族：</span>
            <el-select v-model="minzu" placeholder="请选择" @change="minzuPickerChange">
              <el-option
                v-for="item in minzuPickers"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="owner-item">
          <div style="display:flex;width: 100%;align-items: center;">
            <span>政治面貌</span>
            <el-select v-model="zhengzhi" placeholder="请选择" @change="zhengzhiPickerChange">
              <el-option
                v-for="item in zhengzhiPickers"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="owner-item">
          <div style="display:flex;width: 100%;">
            出生日期：
            <div
              style="position:relative;left:138px;color:rgb(102,102,102);"
              @click="showPopup"
            >{{birth}}</div>
            <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择出生日期"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="showPopup()"
                @confirm="chooseBirth()"
              />
            </van-popup>
          </div>
        </div>

        <div class="owner-item" style="height:50px;">
          <div style="display:flex;width: 100%;position: relative;">
            住址：
            <textarea
              placeholder="请输入住址"
              placeholder-style="color:#bfbfbf"
              v-model="submitData.permanentAddress"
              style="height:45px;width:245px;color:#666;text-align:right;font-size:16px;border:none;"
            ></textarea>
          </div>
        </div>

        <div class="owner-item">
          <div style="display:flex;width: 100%;">
            身份证号：
            <input
              placeholder="请输入身份证号"
              placeholder-style="color:#bfbfbf"
              maxlength="18"
              v-model="submitData.personneCardNo "
            />
          </div>
        </div>

        <div class="owner-item">
          <div style="display:flex;width: 100%;">
            手机号码：
            <input
              placeholder="请输入手机号码"
              placeholder-style="color:#bfbfbf"
              maxlength="11"
              v-model="submitData.mobile"
            />
          </div>
        </div>
      </div>

      <div class="houseMsg-title">
        <img :src="staticImage+'houseMsgIcon.png'" />
        <span>公司信息</span>
      </div>
      <div class="picker">
        <div class="picker-item">
          园区
          <template v-if="hasVillage">
            <el-select v-model="village" placeholder="请选择" @change="villagePickersrChange">
              <el-option
                v-for="item in villagePickers"
                :key="item.id"
                :label="item.xqmc"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <div class="picker-select" style="color:#bfbfbf;">暂无可选园区</div>
          </template>
        </div>

        <div class="picker-item">
          楼栋
          <template v-if="hasBuildings">
            <el-select v-model="building" placeholder="请选择" @change="buildingsPickerChange">
              <el-option
                v-for="item in buildingsPickers"
                :key="item.buildingId"
                :label="item.buildingLabel"
                :value="item.buildingId"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <div class="picker-select" style="color:#bfbfbf;">暂无可选楼栋</div>
          </template>
        </div>

        <div class="picker-item">
          区域
          <template v-if="hasHouse">
            <el-select v-model="house" filterable placeholder="请选择" @change="housePickersChange">
              <el-option
                v-for="item in housePickers"
                :key="item.id"
                :label="item.roomNo"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <div class="picker-select" style="color:#bfbfbf;">暂无可选区域</div>
          </template>
        </div>

        <div class="owner-item">
          <div style="display:flex;width: 100%;">
            公司名称：
            <input
              placeholder="请输入公司名称"
              placeholder-style="color:rgb(191, 191, 191);"
              maxlength="11"
              v-model="company"
            />
          </div>
        </div>

        <div class="owner-item">
          <div style="display:flex;width: 100%;">
            部门名称：
            <input
              placeholder="请输入部门名称"
              placeholder-style="color:rgb(191, 191, 191);"
              maxlength="11"
              v-model="bumen"
            />
          </div>
        </div>
      </div>

      <div class="submit-btn" @click="submit">
        <span>提交</span>
      </div>
    </div>

    <div v-if="isOtherPage">
      <div v-if="showId">
        <div class="showId">
          <div class="showId-view">
            <div @click="hideFloat" class="close">
              <img src="../../public/close.png" />
            </div>
            <img src="../../public/updateCard.png" />
            <a href="javascript:;" class="file">
              点击上传证件照片
              <input type="file" @change="updateCard($event)" id="uploadFile" name />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-if="showId">
        <div class="showId">
          <div class="showId-view">
            <div @click="hideFloat" class="close">
              <img src="../../public/close.png" />
            </div>
            <img :src="staticImage+'updateIDcard.png'" />
            <a href="javascript:;" class="file">
              点击上传身份照片
              <input type="file" @change="updateIdCard($event)" id="uploadFile" name />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showFace">
      <div class="showId">
        <div class="showId-view">
          <div @click="hideFloat" class="close">
            <img src="../../public/close.png" />
          </div>
          <img src="../../public/updateFace.png" />
          <a href="javascript:;" class="file">
            点击上传人脸照片
            <input type="file" @change="updateFacePic($event)" id="uploadFile" name />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false, //是否显示出生日期悬浮层
      minDate: new Date(1900, 0, 1), //出生日期可选最小时间
      maxDate: new Date(), //出生日期可选最大时间
      currentDate: new Date(2000, 0, 1), //当前选中的时间
      title: "园区采集", //页面标题
      staticImage: this.$common.staticImage, //静态图片地址
      typePickers: [], //证件类型pickers
      minzuPickers: [], //民族类型pickers
      guojiPickers: [], //国际类型pickers
      rybqPickers: [], //人员标签piclers
      zhengzhiPickers: [], //政治面貌pickers
      educationPickers: [], //文化程度pickers
      marryPickers: [], //婚姻状况pickers
      villagePickers: [], //小区pickers
      buildingsPickers: [], //楼栋pickers
      unitPickers: [], //单元pickers
      levelPickers: [], //楼层pickers
      housePickers: [], //房屋pickers
      identityPickers: [], //身份pickers
      rklxPickers: [], //人员类型pickers
      hasVillage: false, //是否有小区
      hasBuildings: false, //是否有楼栋
      hasUnit: false, //是否有单元
      hasLevel: false, //是否有楼层
      hasHouse: false, //是否有房屋
      info: {
        name: "",
        sex: "",
        minzu: "",
        birth: "",
        addr: "",
        idNo: "",
        idCardPic: "",
        facePic: "",
      }, //信息对象
      carInfo: {
        pNumber: "", //车牌号
        brand: "", //车辆品牌
        cType: "", //车辆型号
        cColor: "", //车辆颜色
      }, //车辆信息对象
      submitData: {
        personneName: null, //姓名
        personneSex: null, //性别
        nationality: null, //民族名称
        nationCode: null, //民族代码
        type: 1, //1：境内 2：境外
        classify: null, //人员标签
        country: null, //国际字典code
        birthday: "2000-01-01", //用户出生日期
        personneCardNo: null, //用户公民身份证
        permanentAddress: null, //身份证对应的地址
        residenceAddress: null, //实际居住地址
        inputType: 2, //信息录入方式 1读卡录入，2手工录入
        livingWay: 1, ////居住方式1 单身居住
        checkInState: 1, // 入住状态 0待入住（审核中），1入住，2注销（离开）
        cardImage: null, //身份证照片
        showPhotoUrl: null, //人员照片
        mobile: null, //手机号码
        zzmm: null, //政治面貌
        zzmmdm: null, //政治面貌代码
        whcd: 0, //文化程度
        hyzt: 0, //婚姻状况
        zjlx: 0, //证件类型
        grantWay: 1, //授权方式
        personneType: 1, //人口类型
        houseIdsStr: [], //多个参数新增时使用
        toBeginTime: null, //入住开始时间
        toEndTime: null, //入住开始时间
        houseId: null, //房屋id
        relation: null, //人员关系
        fwbm: null, //房屋编码
        xqbm: null, //小区编码
        buildingId: null, //楼栋id
        communityId: null, //小区id
        // type: null, //类型 0：不是 1：是户主
        status: 0, //0：在家；1：外出；2：搬离
        jtgxdm: 8, //家庭关系代码
        personHouseRelationDomain: {},
        personalCarDomains: [
          // pNumber: null, //车牌号
          // brand: null, //车辆品牌
          // cType: null, //车辆型号
          // cColor: null //车辆颜色
        ],
      }, //提交数据对象
      type: "", //被选中的证件类型
      minzu: "", //被选中的民族
      guoji: "", //国籍
      rybq: "", //人员标签
      zhengzhi: "", //政治面貌
      education: "", //文化程度
      marry: "", //婚姻状况
      rklx: "", //人员类型
      village: "", //小区
      building: "", //楼栋
      unit: "", //单元
      level: "", //楼层
      house: "", //房屋
      identity: "", //身份
      isOtherPage: false, //证件类型是否是身份证,false即是身份证
      showId: false, //显示身份证上传浮窗
      showFace: false, //显示人脸上传浮窗
      cardPic: "", //身份证照片
      isMark: true, //是否标记周末
      showDatePicker: false, //是否显示日期选择器
      birth: "2000-01-01", //出生日期
      villageParams: {}, //获取小区请求数据
      buildingParams: {
        communityId: null, //小区id
        xqbm: null, //小区编码
      }, //获取楼栋请求数据
      housesParams: {
        communityId: null, //小区id
        buildingId: null, //楼栋id
        dyh: null, //单元号
        level: null, //楼层
      }, //获取房屋时请求数据
      rotateData: {
        picData: null, //照片变量
      }, //判断身份证照片是否歪了
      postDataId: {
        picData: null,
      }, //身份证识别请求数据
      faceData: {
        destData: "", //身份证照片
        srcData: "", //人脸照片
      }, //人脸比对请求数据
      a: {
        picData: null,
      }, //人脸照片剪裁请求数据
      getListByCode: {
        codes: [
          "certificate_type",
          "MZDM",
          "GJDM",
          "person_label",
          "politics_visage",
          "culture",
          "marital_status",
          "FAMILY_TIES",
          "RKLXDM",
        ],
      },
      unitObj: null, //获取单元时的一个中间data变量
      shouldAgainUpdate: false, //身份证照片需要重新上传
      shouldRotate: false, //人脸照片歪了
      againUpdateFace: false, //人脸照片需要重新上传
      cannotCut: false, //人脸照片质量不过关
      xqmc: null, //小区名称
      buildingLabel: null, //楼栋
      unitname: null, //单元
      roomNo: null, //房间号
      touched: true, //是否可以点击提交按
      company: "", //公司名称
      bumen: "", //部门名称
    };
  },
  mounted() {
    var that = this;
    that
      .post("api-apmuc/communityRest/queryCommunitys", that.villageParams)
      .then((res) => {
        console.log(res);
        if (res.data.length) {
          that.hasVillage = true;
          that.villagePickers = res.data;
          that.village = that.villagePickers[0].id;
          that.buildingParams.communityId = that.villagePickers[0].id;
          that.submitData.communityId = that.villagePickers[0].id;
          that.xqmc = that.villagePickers[0].xqmc;
          that.buildingParams.xqbm = that.villagePickers[0].xqbm;
          that.submitData.xqbm = that.villagePickers[0].xqbm;
          that.housesParams.communityId = that.villagePickers[0].id;
          that
            .post(
              "api-apmuc/buildingRest/queryBuildingByCid",
              that.buildingParams
            )
            .then((r) => {
              console.log(r.data.buildingInfo);
              if (r.data.buildingInfo.length) {
                that.hasBuildings = true;
                that.buildingsPickers = r.data.buildingInfo;
                // that.building = that.buildingsPickers[0].buildingId;
              }
            });
        }
      });
    let code = that.getListByCode.codes;
    let args = {
      codes: `${code[0]},${code[1]},${code[2]},${code[3]},${code[4]},${code[5]},${code[6]},${code[7]},${code[8]}`,
    };
    that.get("api-user/dict/listByCode", args).then((res) => {
      this.typePickers = res.CERTIFICATE_TYPE;
      this.type = res.CERTIFICATE_TYPE[0].code;
      this.minzuPickers = res.MZDM;
      this.minzu = res.MZDM[0].code;
      this.submitData.nationCode = res.MZDM[0].code;
      this.submitData.nationality = res.MZDM[0].name;
      this.guojiPickers = res.GJDM;
      this.guoji = res.GJDM[0].code;
      this.guojiPickers = res.GJDM;
      this.guoji = res.GJDM[0].code;
      this.submitData.country = res.GJDM[0].code;
      this.rybqPickers = res.PERSON_LABEL;
      this.rybqPickers = res.PERSON_LABEL;
      this.zhengzhiPickers = res.POLITICS_VISAGE;
      this.zhengzhi = res.POLITICS_VISAGE[0].code;
      this.submitData.zzmm = res.POLITICS_VISAGE[0].name;
      this.submitData.zzmmdm = res.POLITICS_VISAGE[0].code;
      this.educationPickers = res.CULTURE;
      this.marryPickers = res.MARITAL_STATUS;
      this.identityPickers = res.FAMILY_TIES;
      this.rklxPickers = res.RKLXDM;
    });
  },
  methods: {
    //底部弹出
    showPopup() {
      this.show = !this.show;
    },
    //出生日期选择
    chooseBirth() {
      this.showPopup();
      var year = this.currentDate.getFullYear();
      if (this.currentDate.getMonth() + 1 < 10) {
        var month = "0" + (this.currentDate.getMonth() + 1);
      } else {
        var month = this.currentDate.getMonth() + 1;
      }
      if (this.currentDate.getDate() < 10) {
        var day = "0" + this.currentDate.getDate();
      } else {
        var day = this.currentDate.getDate();
      }
      var date = year + "-" + month + "-" + day;
      this.birth = date;
      this.submitData.birthday = date;
    },
    //证件类型选择
    getType() {
      // getApp().globalData.idcardpic = ''
      // getApp().globalData.idcardpicbase = ''
      // getApp().globalData.facepic = ''
      this.cardPic = null;
      this.info.idCardPic = "";
      this.info.name = "";
      this.info.minzu = "";
      this.info.addr = "";
      this.info.idNo = "";
      this.info.birth = "";
      this.info.sex = "";
      this.info.facePic = "";
      this.birth = "2000-01-01";
      this.submitData.personalCarDomains = [];
      this.submitData.mobile = null;
      this.zhengzhi = this.zhengzhiPickers[0].name;
      this.rybq = null;
      this.guoji = this.guojiPickers[0].code;
      this.marry = null;
      this.education = null;
      this.village = this.villagePickers[0].id;
      this.hasUnit = false;
      this.hasLevel = false;
      this.hasHouse = false;
      this.building = "";
      this.identity = "";
      this.shouldAgainUpdate = false;
      this.shouldRotate = false;
      this.againUpdateFace = false;
      this.cannotCut = false;
      this.carInfo.pNumber = "";
      this.carInfo.brand = "";
      this.carInfo.cType = "";
      this.carInfo.cColor = "";
      this.submitData.personalCarDomains = [];
      this.submitData.personneName = null;
      this.submitData.personneSex = null;
      this.submitData.nationality = null;
      this.submitData.birthday = "2000-01-01";
      this.submitData.permanentAddress = null;
      this.submitData.personneCardNo = null;
      this.submitData.cardImage = null;
      this.submitData.showPhotoUrl = null;
      this.submitData.zzmm = null;
      this.submitData.zzmmdm = null;
      this.submitData.whcd = null;
      this.submitData.hyzt = null;
      this.submitData.zjlx = this.type;
      this.submitData.houseId = null;
      this.submitData.houseIdsStr = [];
      this.submitData.relation = null;
      this.submitData.fwbm = null;
      this.submitData.xqbm = this.villagePickers[0].xqbm;
      this.submitData.buildingId = null;
      this.submitData.communityId = this.villagePickers[0].id;
      this.submitData.type = null;
      this.submitData.jtgxdm = null;
      if (this.type != 0) {
        this.isOtherPage = true;
      } else {
        this.isOtherPage = false;
      }
      if (this.type != 0 && this.type != 1) {
        this.submitData.type = 2;
      } else {
        this.submitData.type = 1;
      }
      this.buildingParams.communityId = this.villagePickers[0].id;
      this.buildingParams.xqbm = this.villagePickers[0].xqbm;
      this.housesParams.communityId = this.villagePickers[0].id;
      this.post(
        "api-apmuc/buildingRest/queryBuildingByCid",
        this.buildingParams
      ).then((r) => {
        console.log(r.data.buildingInfo);
        if (r.data.buildingInfo.length) {
          this.hasBuildings = true;
          this.buildingsPickers = r.data.buildingInfo;
          // this.building = this.buildingsPickers[0].buildingId;
        }
      });
      console.log(this.submitData);
    },
    //政治面貌选择
    zhengzhiPickerChange() {
      this.zhengzhiPickers.map((item, i) => {
        if (item.code == this.zhengzhi) {
          this.submitData.zzmmdm = item.code;
          this.submitData.zzmm = item.name;
        }
      });
    },
    //获取性别
    getSex() {
      console.log(this.info.sex);
      if (this.info.sex == "男") {
        this.submitData.personneSex = 1;
      } else if (this.info.sex == "女") {
        this.submitData.personneSex = 2;
      }
    },
    //国籍选择
    guojiPickerChange() {
      this.minzuPickers.map((item, i) => {
        if (item.code == this.minzu) {
          this.submitData.nationality = item.name;
          this.submitData.nationCode = item.code;
        }
      });
    },
    //民族选择
    minzuPickerChange() {
      this.minzuPickers.map((item, i) => {
        if (item.code == this.minzu) {
          this.submitData.nationality = item.name;
          this.submitData.nationCode = item.code;
        }
      });
    },
    //人员标签选择
    rybqPickerChange() {
      this.submitData.classify = this.rybq;
    },
    //人口类型选择
    rklxPickerChange() {
      this.submitData.personneType = this.rklx;
    },
    //文化程度选择
    educationPickersrChange() {
      this.submitData.whcd = this.education;
    },
    //婚姻状况选择
    marryPickersrChange() {
      this.submitData.hyzt = this.marry;
    },
    //小区选择
    villagePickersrChange() {
      var that = this;
      console.log(this.village);
      that.villagePickers.map((item, i) => {
        if (item.id == that.village) {
          that.buildingParams.communityId = item.id;
          that.submitData.communityId = item.id;
          that.buildingParams.xqbm = item.xqbm;
          that.submitData.xqbm = item.xqbm;
          that.xqmc = item.xqmc;
          that.buildingLabel = null;
          that.unitname = null;
          that.roomNo = null;
        }
      });
      that
        .post("api-apmuc/buildingRest/queryBuildingByCid", that.buildingParams)
        .then((res) => {
          console.log(res.data.buildingInfo);
          if (res.data.buildingInfo.length) {
            that.hasBuildings = true;
            that.buildingsPickers = res.data.buildingInfo;
            that.building = "";
            that.unit = "";
            that.level = "";
            that.house = "";
            that.hasUnit = false;
            that.hasLevel = false;
            that.hasHouse = false;
          }
        });
    },
    //楼栋选择
    buildingsPickerChange() {
      var that = this;
      console.log(that.buildingsPickers);
      that.buildingsPickers.map((item, i) => {
        if (item.buildingId == that.building) {
          that.housesParams.buildingId = item.buildingId;
          that.submitData.buildingId = item.buildingId;
          that.buildingLabel = item.buildingLabel;
          that.unitname = null;
          that.roomNo = null;
        }
      });
      that
        .post("api-apmuc/houseRest/queryHouses", that.housesParams)
        .then((res) => {
          console.log(res);
          for (var i in res.data) {
            if (res.data[i].roomNo.substring(0, 1) == "-") {
              res.data[i].roomNo = "负" + res.data[i].roomNo.substring(1, 4);
            }
          }
          that.housePickers = res.data;
          that.house = "";
          if (that.housePickers.length) {
            that.hasHouse = true;
          } else {
            that.hasHouse = false;
          }
        });
    },
    //房屋选择
    housePickersChange() {
      var that = this;
      that.housePickers.map((item, i) => {
        if (item.id == that.house) {
          this.submitData.fwbm = item.fwbm;
          this.submitData.houseId = item.id;
          this.submitData.houseIdsStr[0] = item.id + ",8";

          this.roomNo = item.roomNo;
        }
      });
    },

    //身份证上传回调方法
    callbackId(e) {
      this.chooseIdCard(e);
    },
    //人脸照片上传回调方法
    callbackFace(e) {
      this.chooseFacePic(e);
    },
    //证件照片上传回调方法
    callbackCard(e) {
      var centerPic = "data:image/jpeg;base64," + e;
      this.chooseCard(centerPic);
    },
    //身份证照片上传
    updateIdCard(e) {
      this.getPic(e.target.files[0], this.callbackId);
    },
    //证件照片上传
    updateCard(e) {
      let imgSrc = window.URL.createObjectURL(e.target.files[0]);
      var url = this.compressImg(imgSrc, this.callbackCard);
    },
    //人脸照片上传
    updateFacePic(e) {
      this.getPic(e.target.files[0], this.callbackFace);
    },
    //身份证照片上传子方法
    chooseIdCard(e) {
      var that = this;
      that.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "上传中...",
      });
      that.rotateData.picData = e;
      console.log(that.rotateData);
      that.post("api-algo/frpRest/faceDetect", that.rotateData).then((res) => {
        if (res.status == 0) {
          that.postDataId.picData = e;
          that.post("api-algo/ocrRest/ocrIDCard", that.postDataId).then((r) => {
            console.log(r);
            if (res.data.status == -1) {
              that.shouldAgainUpdate = true;
            } else {
              that.info.name = r.data.name;
              that.submitData.personneName = r.data.name;
              that.info.minzu = r.data.ethnicity;
              that.submitData.nationality = r.data.ethnicity;
              that.info.addr = r.data.address;
              that.submitData.permanentAddress = r.data.address;
              that.info.idNo = r.data.number;
              that.submitData.personneCardNo = r.data.number;
              that.info.birth = r.data.birth;
              that.submitData.birthday = r.data.birth;
              that.birth = r.data.birth;
              that.info.sex = r.data.sex;
              if (r.data.sex == "男") {
                that.submitData.personneSex = 1;
              } else if (r.data.sex == "女") {
                that.submitData.personneSex = 2;
              }
              that.info.idCardPic = e;
              that.shouldAgainUpdate = false;
              that.shouldRotate = false;
            }
            that.hideFloat();
            that.$toast.clear();
          });
        } else {
          that.shouldRotate = true;
          that.hideFloat();
          that.$toast.clear();
        }
      });
      // console.log();
    },
    //人脸照片上传子方法
    chooseFacePic(e) {
      let that = this;
      if (that.isOtherPage) {
        that.info.facePic = e;
        that.submitData.showPhotoUrl = e;
        that.hideFloat();
      } else {
        if (that.info.idCardPic.length == 0) {
          this.$toast("请先上传身份证照片");
          that.hideFloat();
        } else {
          that.$toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "上传中...",
          });
          that.faceData.destData = that.info.idCardPic;
          that.submitData.cardImage = that.faceData.destData;
          that.a.picData = e;
          that.post("api-algo/frpRest/faceDetectCut", that.a).then((res) => {
            console.log(res);

            if (res.status == -1) {
              that.cannotCut = true;
              that.shouldRotate = false;
              that.againUpdateFace = false;
              that.hideFloat();
              that.$toast.clear();
              return;
            } else {
              that.cannotCut = false;
              that.shouldRotate = false;
              that.againUpdateFace = false;
            }
            var a = "data:image/jpeg;base64," + res.data;
            that.faceData.srcData = a;
            that.submitData.showPhotoUrl = that.faceData.srcData;
            that.rotateData.picData = that.faceData.srcData;
            that
              .post("api-algo/frpRest/faceCompare", that.faceData)
              .then((r) => {
                console.log(r);
                if (r.status != 0) {
                  that.shouldRotate = true;
                  that.againUpdateFace = false;
                } else {
                  that.shouldRotate = false;
                  that.againUpdateFace = false;
                }
                if (r.data.isSame == 1) {
                  var facePic = "";
                  that.info.facePic = a;
                  that.againUpdateFace = false;
                } else {
                  that.againUpdateFace = true;
                }
              });
            that.hideFloat();
            that.$toast.clear();
          });
        }
      }
    },
    //证件照片上传子方法
    chooseCard(e) {
      this.cardPic = e;
      this.submitData.cardImage = e;
      this.hideFloat();
    },
    //提交方法
    submit() {
      if (!this.company || !this.bumen) {
        this.$dialog.alert({
          title: "提示",
          message: "请将公司信息填写完整",
        });
        return;
      }
      this.submitData.relation = this.company + "," + this.bumen;
      console.log(this.submitData);

      if (
        this.carInfo.pNumber != "" &&
        this.carInfo.brand != "" &&
        this.carInfo.cType != "" &&
        this.carInfo.cColor != ""
      ) {
        this.submitData.personalCarDomains[0] = this.carInfo;
      } else {
        if (
          this.carInfo.pNumber == "" &&
          this.carInfo.brand == "" &&
          this.carInfo.cType == "" &&
          this.carInfo.cColor == ""
        ) {
        } else {
          this.$dialog.alert({
            title: "提示",
            message: "请将车辆信息填写完整",
          });
          return;
        }
      }
      console.log(this.carInfo);
      this.submitData.residenceAddress =
        this.xqmc +
        this.buildingLabel +
        this.roomNo +
        this.company +
        this.bumen;
      console.log(this.submitData);
      console.log(this.info);
      if (
        !this.submitData.personneName ||
        !this.submitData.personneSex ||
        !this.submitData.nationality ||
        !this.submitData.personneType ||
        !this.submitData.birthday ||
        !this.submitData.permanentAddress ||
        !this.submitData.cardImage ||
        !this.submitData.showPhotoUrl ||
        !this.submitData.personneCardNo
      ) {
        if (!this.submitData.cardImage) {
          this.$dialog.alert({
            title: "提示",
            message: "请上传证件照",
          });
        } else if (!this.submitData.showPhotoUrl) {
          this.$dialog.alert({
            title: "提示",
            message: "请上传人脸照",
          });
        } else if (!this.submitData.personneName) {
          this.$dialog.alert({
            title: "提示",
            message: "请填写姓名",
          });
        } else if (!this.submitData.personneSex) {
          this.$dialog.alert({
            title: "提示",
            message: "请填写性别",
          });
        } else if (!this.submitData.personneType) {
          this.$dialog.alert({
            title: "提示",
            message: "请选择人口类型",
          });
        } else if (!this.submitData.nationality) {
          this.$dialog.alert({
            title: "提示",
            message: "请选择民族",
          });
        } else if (!this.submitData.birthday) {
          this.$dialog.alert({
            title: "提示",
            message: "请选择出生日期",
          });
        } else if (!this.submitData.permanentAddress) {
          this.$dialog.alert({
            title: "提示",
            message: "请填写住址",
          });
        } else if (!this.submitData.personneCardNo) {
          this.$dialog.alert({
            title: "提示",
            message: "请填写身份证号码",
          });
        }
      } else if (
        this.submitData.houseId == null ||
        this.submitData.relation == null ||
        this.submitData.fwbm == null ||
        this.submitData.xqbm == null ||
        this.submitData.type == null ||
        this.submitData.jtgxdm == null
      ) {
        console.log(this.submitData);
        this.$dialog.alert({
          title: "提示",
          message: "请将房屋信息填写完整",
        });
      } else {
        if (this.submitData.type == 1) {
          if (!this.submitData.mobile) {
            this.$dialog.alert({
              title: "提示",
              message: "请填写手机号",
            });
            return;
          }
          if (!/^1[3456789]\d{9}$/.test(this.submitData.mobile)) {
            this.$dialog.alert({
              title: "提示",
              message: "请填写正确的手机号码",
            });
            return;
          }
        }
        if (this.submitData.zjlx == 0 || this.submitData.zjlx == 1) {
          if (
            !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
              this.submitData.personneCardNo
            )
          ) {
            this.$dialog.alert({
              title: "提示",
              message: "请填写正确的身份证号码",
            });
            return;
          }
        }
        if (this.touched) {
          this.touched = false;
          this.post(
            "api-apmuc/personHouseRelationRest/v2.0/addMultiPersonHouseRelation",
            this.submitData
          ).then((res) => {
            console.log(res);
            if (res.status == 0) {
              this.$toast.success({
                message: "添加成功",
                duration: 5000,
              });
              this.touched = true;
            } else {
              this.$toast(res.errMsg);
              this.touched = true;
            }
            console.log(this.touched);
          });
        }
      }
    },
    //显示悬浮框
    showFloat(e) {
      if (e == 1) {
        this.showId = true;
      } else {
        this.showFace = true;
      }
    },
    //隐藏悬浮框
    hideFloat() {
      this.showId = false;
      this.showFace = false;
    },
    //点击图片可放大
    showPic() {},
    //删除图片
    DelImg(e) {
      this.$dialog
        .confirm({
          title: "删除图片",
          message: "确定要删除这张图片吗",
          confirmButtonColor: "#2dc5e0",
        })
        .then(() => {
          if (e == 1) {
            this.info.idCardPic = "";
            this.info.name = "";
            this.info.minzu = "";
            this.info.addr = "";
            this.info.idNo = "";
            this.info.birth = "";
            this.birth = "2000-01-01";
            this.info.sex = "";
            this.info.facePic = "";
            this.submitData.cardImage = null;
            this.submitData.showPhotoUrl = null;
            this.shouldAgainUpdate = false;
            this.shouldRotate = false;
            this.againUpdateFace = false;
            this.cannotCut = false;
          } else if (e == 2) {
            this.info.facePic = "";
            this.submitData.showPhotoUrl = null;
          }
        })
        .catch(() => {
          console.log("点击了取消");
        });
    },
    handleCancel() {
      this.showDatePicker = false;
    },
    handleConfirm(item) {
      console.log(item);
      this.birth = item;
      this.showDatePicker = false;
    },
    disableDate(item) {
      if (
        new Date(item) - new Date("2019-8-10") >= 0 &&
        new Date("2019-8-20") - new Date(item) >= 0
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.personalMsg {
  width: 90%;
  margin: 15px auto;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px #ccc;
}
.personalMsg-title {
  width: 90%;
  margin: 15px auto;
  font-size: 16px;
}
.personalMsg-title > img {
  width: 30px;
  height: 22.5px;
  position: relative;
  top: 5px;
}
.personalMsg-title > span {
  margin-left: 15px;
}
.owner-item {
  width: 90%;
  margin: 0 auto;
  border-bottom: 1px solid #e6e6e6;
  padding: 15px 0;
  display: flex;
  font-size: 16px;
}
.owner-item:last-child {
  border-bottom: none;
}
.owner-item > div:nth-child(2) {
  position: relative;
  left: 15px;
}
.owner-item > div > span {
  width: 85px;
  display: flex;
  align-items: center;
}
.owner-item > div > input {
  width: 70%;
  text-align: right;
  color: #666;
  /* font-weight: normal; */ /* display: inline-block;*/
  top: 5px;
  position: relative;
  z-index: 0;
  border: none;
  font-size: 16px;
}
.type_select {
  width: 180px;
  font-size: 16px;
  height: 26px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #fff;
  direction: rtl;
}
.house_select {
  width: 130px;
  font-size: 16px;
  height: 26px;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #fff;
  direction: rtl;
}
.owner-pic {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}
.norotate {
  width: 100%;
  height: 100%;
}
.owner-pic > div {
  width: 130px;
  height: 130px;
  margin: 15px 0;
  border: 1px dashed #ccc;
  text-align: center;
  color: #ccc;
  overflow: hidden;
}
.jia {
  display: block;
  position: relative;
  top: 22px;
  font-size: 40px;
}
.text {
  display: block;
  position: relative;
  top: 25px;
  font-size: 16px;
}
.picker {
  width: 90%;
  margin: 0 auto;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px #ccc;
  margin-bottom: 25px;
  font-size: 16px;
}
.picker-select {
  color: #666;
  height: 40px;
  display: flex;
  align-items: center;
}
.picker-select > text {
  margin-right: 12rpx;
}
.houseMsg-title {
  width: 90%;
  margin: 15px auto;
  font-size: 16px;
}
.houseMsg-title > img {
  width: 35px;
  height: 22px;
  position: relative;
  top: 5px;
}
.houseMsg-title > span {
  margin-left: 10px;
}
.picker-item {
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  border-bottom: 1px solid #e6e6e6;
}
.picker-item:last-child {
  border-bottom: none;
}
.carMsg-title {
  width: 90%;
  margin: 15px auto;
  font-size: 16px;
}
.carMsg-title > img {
  width: 26px;
  height: 23px;
  position: relative;
  top: 5px;
}
.carMsg-title > span {
  margin-left: 10px;
}
.submit-btn {
  width: 90%;
  height: 50px;
  margin: 15px auto;
  background: #2dc5e0;
  color: #fff;
  font-size: 18px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.submit-btn > button {
  background: #2dc5e0;
  color: #fff;
  font-size: 18px;
}
.showId {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.4);
}
.showId-view {
  width: 90%;
  height: 218px;
  background: white;
  margin: 0 auto;
  position: relative;
  top: 36%;
  text-align: center;
}
.showId-view > img {
  width: 282px;
  height: 120px;
  margin-top: 31px;
}
.close {
  width: 25px;
  height: 25px;
  float: right;
  position: relative;
  top: -8px;
  right: 10px;
}
.close > img {
  width: 10px;
  height: 10px;
}
.showId-btn {
  width: 60%;
  height: 35px;
  margin: 0 auto;
  background: #2dc5e0;
  color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  margin-top: 10px;
}
.file {
  width: 60%;
  height: 35px;
  margin: 0 auto;
  background: #2dc5e0;
  color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  text-indent: 0;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.DelImg {
  width: 0% !important;
  height: 0rpx !important;
  margin: 30rpx !important;
  border: none !important;
  text-align: none !important;
  color: none !important;
  /* position: absolute; */
}
.rotateDelImg {
  width: 0% !important;
  height: 0rpx !important;
  margin: 30rpx !important;
  border: none !important;
  text-align: none !important;
  color: none !important;
  /* position: absolute; */
}
.DelImg > img {
  width: 14px;
  height: 14px;
  background: #ccc;
  opacity: 0.6;
  position: relative;
  top: -155px;
  left: 115px;
}
</style>